import styled from 'styled-components'
import tw from 'twin.macro'

import { isPresent } from 'utils'

export const Label = styled.label`
  ${tw`absolute left-0 pointer-events-none select-none`};
  color: red;
  /* color: var(--color-blue-grey); */
  transform-origin: top left;
  transform: translateY(1rem);
  transition: transform 0.2s var(--ease-in-out-cubic), color 0.2s var(--ease-in-out-cubic);

  color: ${({ $error }) => (isPresent($error) ? 'var(--color-danger)' : 'var(--color-blue-grey)')};

  ${({ $inputPresent, $error }) =>
    $inputPresent && {
      color: isPresent($error) ? 'var(--color-danger)' : 'var(--color-gold-black)',
      transform: 'translateY(-0.3rem) scale(0.75)',
    }};
`

export const Root = styled.div`
  ${tw`relative border-b`};
  /* border-color: var(--color-black); */
  border-color: ${({ $error }) => (isPresent($error) ? 'var(--color-danger)' : 'var(--color-black)')};

  /* &::before {
    content: '';
    ${tw`absolute left-0 bottom-0 w-full h-2 translate-y-1/2`};
    z-index: -1;
    background-color: var(--color-input-bg);
  } */

  &:focus-within {
    /* border-color: var(--color-gold); */
  }

  /* &:focus-within ${Label} {
    color: var(--color-gold-black);
    transform: translateY(-5px) scale(0.8);
  } */
`

export const Input = styled.input.attrs((props) => ({ ...props }))`
  ${tw`block w-full py-4 outline-none resize-none`};

  font-family: var(--font-nhu);
  font-weight: 300;
  letter-spacing: 0.028em;
`
